<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-show="camplist&&camplist.length"
            >
                <ul>
                    <li v-for="(item,index) in camplist" :key="index" @click="trainingMsg(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.iconUrl" alt="">
                            <div class="_clear" v-show="item.isNewTrain">
                                <p class="learning-list-left-new">
                                    <img src="../../../assets/images/learning/new1.png" alt="">
                                    <span>NEW</span>
                                </p>
                            </div>
                            
                        </div>
                        <div class="learning-list-right">
                            <h4>{{item.name}}</h4>
                            <p class="learning-list-right-time learning-list-right-bottom _clear">
                                <img src="../../../assets/images/learning/time.png" alt="">
                                学习时长{{formateTime(item.learnTotalTime)}}小时<span>|</span>已完成{{item.studyProcess}}%
                            </p>
                            <p class="learning-list-right-validity learning-list-right-validity1" v-if="learnValidity">有效期至：{{formatTime(item.trainEndTime)}}</p>
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-if="!camplist.length">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            showLoading: true,
            loading:false,
            finished:false,
            filter: {
                pageNum: 1,
                pageSize:20,
                trainStatus: ""
            },
            total: 0,
            camplist:[],
            loadMoreStatus: "more",
        };
    },
    props: {
        learnValidity: {
            type: Boolean,
            default: false
        }
    },
    components: {
    },
    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.filter.pageNum = this.filter.pageNum*1 + 1
            this.trainList('reachBottom')
        },
        formateTime(val) {
            if(val){
                if((val / 3600).toFixed(2)>0){
                    return (val / 3600).toFixed(2);
                }else{
                    return (val / 3600).toFixed(0);
                }
                
            }else{
                return val;
            }
            
        },
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.');
            }
        },
        selectcheck(value){
            this.filter={
                pageNum: 1,
                pageSize: 20,
                trainStatus: value
            };
            this.trainList();
        },
        trainList(type) {
            let params = this.filter;
            this.$api.training.trainList({ params }).then((res) => {
                if(res.data && res.data.list){
                    this.showLoading = false;
                    if (type === "reachBottom") {
                        this.camplist = this.camplist.concat(res.data.list);
                    } else {
                        this.camplist = res.data.list || [];
                    }
                    this.total = res.data.total;
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    this.finished = res.data.isLastPage;
                }
                
            });
        },
        trainingMsg(item) {
            if(item.status===3){
                this.$toast({
                message: '已到期，无法学习',
                    duration: 2000,
                });
                return;
            }else{
                if(new Date().getTime()<=new Date(item.trainStartTime).getTime()){
                    this.$toast({
                    message: '训练营还没到开始时间',
                        duration: 2000,
                    });
                    return;
                }else{
                    this.$router.push({
                        path: "/learning/Details",
                        query: {
                            id: item.id,
                            backType:2,
                        }
                    });
                }
            }


            
        },
    },

    mounted(){

    },
}

</script>
<style lang='less'>
@import '../css/learnlist.less';
</style>